import { render } from "./NewFeatures.vue?vue&type=template&id=44605b23&scoped=true&ts=true&lang=pug"
import script from "./NewFeatures.vue?vue&type=script&lang=ts"
export * from "./NewFeatures.vue?vue&type=script&lang=ts"

import "./NewFeatures.vue?vue&type=style&index=0&id=44605b23&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./NewFeatures.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/newfeatures.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FNewFeatures.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44605b23"]])

export default __exports__